const LANGUAGES = {
  cl: 'es'
};

export const LANGUAGE = LANGUAGES[process.env.REACT_APP_ISO_COUNTRY];
export const REQUEST_OK_GOOGLE = 'OK';
